export const pages = [
  { title: 'Stories', link: '/stories' },
  { title: 'Majors', link: '/majors' },
  { title: 'Student Organizations', link: '/organizations' },
  { title: 'Projects', link: '/projects' },
  { title: 'Resources', link: '/resources' },
];
